import boletaApi from "./boletaApi";

export const getCompanyP = async (idUser) => {
  try {
    return await boletaApi.get("/getCompanyProfile", { params: { idUser } });
  } catch (error) {
    const { response } = error;
    return response;
  }
};
